import { makeStyles } from '@material-ui/styles';
const useStyles = makeStyles(theme => ({
    root: {
      padding: theme.spacing(4)
    }
  }));
  
export default useStyles;